import { z } from "zod";
import { DateValidation } from "../shared/date-validation";

const EmployeeSchema = z.object({
  Id: z.string(),
  FullName: z.string(),
  Email: z.string().optional(),
  FirstName: z.string().optional(),
  LastName: z.string().optional(),
  MiddleName: z.string().nullable().optional(),
  HomePhone: z.string().nullable().optional(),
  JobTitle: z.string().optional(),
  IsDisabled: z.boolean().optional(),
  MobilePhone: z.string().optional(),
  Department: z.string().optional(),
  Team: z.string().optional(),
  Skills: z.string().nullable().optional(),
  Title: z.string().optional(),
  TierCode: z.number().optional(),
  ManagerId: z.string().optional(),
  PositionId: z.string().nullable().optional(),
  CalendarId: z.string().optional(),
});

const TimeSlotSchema = z.object({
  DateBegin: DateValidation,
  DateEnd: DateValidation,
  Name: z.string(),
  FreeEmployees: z.array(EmployeeSchema),

  StartYear: z.number().optional(),
  StartMonth: z.number().optional(),
  StartDay: z.number().optional(),
  StartHours: z.number().optional(),
  DurationMinutes: z.number().optional(),
  StartMinutes: z.number().optional(),
  EndHours: z.number().optional(),
  EndMinutes: z.number().optional(),
});

const DaySchema = z.object({
  Date: DateValidation,
  TimeSlots: z.array(TimeSlotSchema),
  Available: z.boolean().optional(),
  Qnt: z.number().optional(),
});

const WeekSchema = z.object({
  Days: z.array(DaySchema),
});

export const ServiceCalendarItemSchema = z.object({
  Weeks: z.array(WeekSchema),
  MonthName: z.string(),
  WeeksCount: z.number().optional(),
  Start: DateValidation,
  End: DateValidation,
  Valid: z.boolean().optional(),
  WeekdayNames: z.array(z.string()),
});

export type ServiceCalendarItemType = z.infer<typeof ServiceCalendarItemSchema>;
export type ServiceCalendarWeekType = z.infer<typeof WeekSchema>;
export type ServiceCalendarDayType = z.infer<typeof DaySchema>;
export type ServiceCalendarTimeSlotType = z.infer<typeof TimeSlotSchema>;
export type ServiceCalendarEmployeeType = z.infer<typeof EmployeeSchema>;
